export const GamePageMenuActionsEnum = {
    HOME: 'home',
    SEARCH: 'search',
    HELP: 'help',
    SOUND_UPDATE: 'soundUpdate',
    HISTORY: 'history',
};
